import { createApiClient } from "./ApiClient";

export const ActivityNotAllowedICDAxiosInstance = createApiClient(
  "ActivityNotAllowedWithIcd/",
);
